<template>
  <div class="footer">
    <ul>
      <li v-for="(item,index) in menuList" :key="index" @click="getLink(index)">{{item}}</li>
    </ul>
    <p><span>Copyright&copy;2020 怀宁县农业农村局 版权所有</span>技术支持：中国联合网络通信有限公司</p>
    <p><a href="https://beian.miit.gov.cn" target="_blacnk">皖ICP备2020016492号</a></p>
    
  </div>
</template>

<script>
export default {
  name: '',
  data () {
    return {
      menuList:[
        '首页',
        '农业知识库',
        '种植经验共享',
        '专家库',
        '知识问答',
        '知识地图',
      ],
    }
  },
  methods:{
    getLink(index){
      this.currentIndex = index;
      let kid = sessionStorage.getItem("knowledgeId");
      let eid = sessionStorage.getItem("experienceId");
      if(kid){
        this.knowledgeId = kid;
      }
      if(eid){
        this.experienceId = eid;
      }
      if (index == 0) {
        this.$router.push({ name: "home" });
      } else if (index == 1) {
        this.$router.push({ path:"/knowledge-list/"+this.knowledgeId });
      } else if (index == 2) {
        this.$router.push({ path:"/experience-list/"+this.experienceId });
      } else if (index == 3) {
        this.$router.push({ path:"/expert-list/0" });
      } else if (index == 4) {
        this.$router.push({ name: "question-list" });
      } else if (index == 5) {
        this.$router.push({ name: "knowledge-map" });
      }
    },
  }
}
</script>

<style scoped>
  .footer{
    margin-top: 40px;
    background:#434343;
    color: #fff;
    text-align: center;
    padding: 20px 0;
    line-height: 34px;
  }
  .footer ul li{
    display: inline;
    padding: 0 15px;
    cursor: pointer;
  }
  .footer  span{
    padding-right: 30px;
  }
  .footer a{
    color: #fff;
  }
</style>4


// WEBPACK FOOTER //
// src/components/footer/footer.vue